import { default as codice_45otphQqKWlphjWMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/codice-otp.vue?macro=true";
import { default as codiceYvW9MzVXrrMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/codice.vue?macro=true";
import { default as indexi46E7Iwdr7Meta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/admin/index.vue?macro=true";
import { default as index7OSnZ7LefRMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/archivio/index.vue?macro=true";
import { default as indexbFLEze82RzMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/clienti/index.vue?macro=true";
import { default as creazione_disegniiSzjdDYQxSMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/creazione_disegni.vue?macro=true";
import { default as descrizionii4tFWdwIT4Meta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/descrizioni.vue?macro=true";
import { default as indexUy2g64v4QXMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/index.vue?macro=true";
import { default as numerazione_aWVnYAN9OAmMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/numerazione_a.vue?macro=true";
import { default as numerazione_bMLMSOFuDh6Meta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/numerazione_b.vue?macro=true";
import { default as indexi7ZQuF5WXDMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/fornitori/index.vue?macro=true";
import { default as indexIa61l4eLZDMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/index.vue?macro=true";
import { default as indexcriry64huNMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/log/index.vue?macro=true";
import { default as createwldBqhM2mvMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/allegato1/create.vue?macro=true";
import { default as indexWDR2b3ZNEZMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/allegato1/index.vue?macro=true";
import { default as createG9f6QkcRBlMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/manuale/create.vue?macro=true";
import { default as indexfyb8QHUUxRMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/manuale/index.vue?macro=true";
import { default as indexxBmSzVr1kTMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/profilo/index.vue?macro=true";
import { default as indexCWdgSuoegJMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/index.vue?macro=true";
import { default as recupera_45passwordNan9wG793HMeta } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/recupera-password.vue?macro=true";
export default [
  {
    name: "codice-otp",
    path: "/codice-otp",
    meta: codice_45otphQqKWlphjWMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/codice-otp.vue")
  },
  {
    name: "codice",
    path: "/codice",
    meta: codiceYvW9MzVXrrMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/codice.vue")
  },
  {
    name: "dashboard-admin",
    path: "/dashboard/admin",
    meta: indexi46E7Iwdr7Meta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/admin/index.vue")
  },
  {
    name: "dashboard-archivio",
    path: "/dashboard/archivio",
    meta: index7OSnZ7LefRMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/archivio/index.vue")
  },
  {
    name: "dashboard-clienti",
    path: "/dashboard/clienti",
    meta: indexbFLEze82RzMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/clienti/index.vue")
  },
  {
    name: "dashboard-disnum-creazione_disegni",
    path: "/dashboard/disnum/creazione_disegni",
    meta: creazione_disegniiSzjdDYQxSMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/creazione_disegni.vue")
  },
  {
    name: "dashboard-disnum-descrizioni",
    path: "/dashboard/disnum/descrizioni",
    meta: descrizionii4tFWdwIT4Meta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/descrizioni.vue")
  },
  {
    name: "dashboard-disnum",
    path: "/dashboard/disnum",
    meta: indexUy2g64v4QXMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/index.vue")
  },
  {
    name: "dashboard-disnum-numerazione_a",
    path: "/dashboard/disnum/numerazione_a",
    meta: numerazione_aWVnYAN9OAmMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/numerazione_a.vue")
  },
  {
    name: "dashboard-disnum-numerazione_b",
    path: "/dashboard/disnum/numerazione_b",
    meta: numerazione_bMLMSOFuDh6Meta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/disnum/numerazione_b.vue")
  },
  {
    name: "dashboard-fornitori",
    path: "/dashboard/fornitori",
    meta: indexi7ZQuF5WXDMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/fornitori/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexIa61l4eLZDMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-log",
    path: "/dashboard/log",
    meta: indexcriry64huNMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/log/index.vue")
  },
  {
    name: "dashboard-manualis-allegato1-create",
    path: "/dashboard/manualis/allegato1/create",
    meta: createwldBqhM2mvMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/allegato1/create.vue")
  },
  {
    name: "dashboard-manualis-allegato1",
    path: "/dashboard/manualis/allegato1",
    meta: indexWDR2b3ZNEZMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/allegato1/index.vue")
  },
  {
    name: "dashboard-manualis-manuale-create",
    path: "/dashboard/manualis/manuale/create",
    meta: createG9f6QkcRBlMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/manuale/create.vue")
  },
  {
    name: "dashboard-manualis-manuale",
    path: "/dashboard/manualis/manuale",
    meta: indexfyb8QHUUxRMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/manualis/manuale/index.vue")
  },
  {
    name: "dashboard-profilo",
    path: "/dashboard/profilo",
    meta: indexxBmSzVr1kTMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/dashboard/profilo/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexCWdgSuoegJMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/index.vue")
  },
  {
    name: "recupera-password",
    path: "/recupera-password",
    meta: recupera_45passwordNan9wG793HMeta || {},
    component: () => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/pages/recupera-password.vue")
  }
]